import { ForgeAppError } from '../ForgeAppError';
import { shouldRenderForgeAppErrorMessage } from '../../renderer/errorMessages/errorTypes';
import type { TBridgeMiddleware } from '../methods/types';

/**
 * Middleware that surfaces an error from the Forge app when a bridge method throws a
 * {@link ForgeAppError} whose `errorType` is classified as display-worthy (e.g. the
 * deprecated-sandbox error). It delegates display to `services.showAppError` — a
 * runtime-provided presenter that owns the overlay + host-renderer suppression + i18n
 * — and always rethrows so the app-side call still rejects and `withMetrics` (inner)
 * still reports to Sentry.
 *
 * Selective by construction: only classified `ForgeAppError`s take over the surface;
 * ordinary errors pass straight through to the app, which renders its own UI.
 */
export const withErrorDisplay: TBridgeMiddleware = (method) => async (context, payload) => {
	try {
		return await method(context, payload);
	} catch (err) {
		if (err instanceof ForgeAppError && shouldRenderForgeAppErrorMessage(err.errorType)) {
			context.services.showAppError(err);
		}
		throw err;
	}
};
